<template>
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 279 280" style="enable-background:new 0 0 279 280;" xml:space="preserve">
		<ellipse id="Ellipse_420" class="st0" cx="139.5" cy="140" rx="139.5" ry="140"/>
		<g>
			<g>
				<g>
					<path class="st1" d="M207.6,85.5H60.5c-4.5,0-8.2,3.7-8.2,8.2v92.6c0,4.5,3.7,8.2,8.2,8.2h147.1c4.5,0,8.2-3.7,8.2-8.2V93.7
						C215.8,89.2,212.1,85.5,207.6,85.5z M210.3,186.3c0,1.5-1.2,2.7-2.7,2.7H60.5c-1.5,0-2.7-1.2-2.7-2.7v-60h152.6L210.3,186.3
						L210.3,186.3z M210.3,120.9H57.8v-16.3h152.6L210.3,120.9L210.3,120.9z M210.3,99.1H57.8v-5.5c0-1.5,1.2-2.7,2.7-2.7h147.1
						c1.5,0,2.7,1.2,2.7,2.7L210.3,99.1L210.3,99.1z"/>
				</g>
			</g>
			<g>
				<g>
					<path class="st1" d="M188.6,153.6c-3.6,0-7,1.4-9.5,3.9c-2.5-2.5-5.9-3.9-9.5-3.9c-7.5,0-13.6,6.1-13.6,13.6
						c0,7.5,6.1,13.6,13.6,13.6c3.6,0,7-1.4,9.5-3.9c2.5,2.5,5.9,3.9,9.5,3.9c7.5,0,13.6-6.1,13.6-13.6
						C202.2,159.7,196.1,153.6,188.6,153.6z M188.6,175.4c-2.9,0-5.6-1.6-7.1-4.1c-0.5-0.8-1.6-1.4-2.5-1.4c0,0,0,0,0,0
						c-1,0-1.8,0.5-2.3,1.4c-1.5,2.5-4.2,4.1-7.1,4.1c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2c2.9,0,5.6,1.6,7.1,4.1
						c0.5,0.9,1.4,1.4,2.4,1.4c1,0.1,2-0.4,2.5-1.4c1.5-2.5,4.2-4.1,7.1-4.1c4.5,0,8.2,3.7,8.2,8.2
						C196.7,171.8,193.1,175.4,188.6,175.4z"/>
				</g>
			</g>
			<g>
				<g>
					<path class="st1" d="M142.2,159.1H115c-1.5,0-2.7,1.2-2.7,2.7v10.9c0,1.5,1.2,2.7,2.7,2.7h27.2c1.5,0,2.7-1.2,2.7-2.7v-10.9
						C145,160.3,143.7,159.1,142.2,159.1z M139.5,170h-21.8v-5.5h21.8L139.5,170L139.5,170z"/>
				</g>
			</g>
			<g>
				<g>
					<path class="st1" d="M98.6,159.1H71.4c-1.5,0-2.7,1.2-2.7,2.7v10.9c0,1.5,1.2,2.7,2.7,2.7h27.2c1.5,0,2.7-1.2,2.7-2.7v-10.9
						C101.4,160.3,100.1,159.1,98.6,159.1z M95.9,170H74.1v-5.5h21.8L95.9,170L95.9,170z"/>
				</g>
			</g>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'cardSvg',
}
</script>

<style scoped>
/* eslint-disable */
.st0 {
	fill: var(--iconsColor1); 
}
.st1 {
	fill: var(--iconsColor2); 
}
svg {
	width: 100%;
	height: 100%;
}
</style>